(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1253);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5249);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var FormFieldDropdown = function(_param) /*#__PURE__*/ {
    var label = _param.label, name1 = _param.name, initialValue = _param.initialValue, _blockClassName = _param.blockClassName, blockClassName = _blockClassName === void 0 ? "block" : _blockClassName, selectId = _param.selectId, options = _param.options, placeholder = _param.placeholder, inputProps = _objectWithoutProperties(_param, [
        "label",
        "name",
        "initialValue",
        "blockClassName",
        "selectId",
        "options",
        "placeholder"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
        name: name1,
        initialValue: initialValue,
        children: function(param1) {
            var input = param1.input, meta = param1.meta;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "label-md text-text-color-high-em dark:text-text-color-high-em-dark",
                        children: label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", _objectSpread({
                        className: "focus:bg-white focus:ring-0 focus:border-secondary-light w-full rounded-lg border-[#D0D5DD] mt-1 text-text-color-mid-em",
                        name: name1,
                        id: selectId
                    }, input, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                value: "",
                                children: placeholder
                            }),
                            options.map(function(param) {
                                var name = param.name, value = param.value;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                    value: value,
                                    children: name
                                }, value);
                            })
                        ]
                    }))
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormFieldDropdown);


/***/ }),

/***/ 2471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5249);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var FormFieldInput = function(_param) /*#__PURE__*/ {
    var label = _param.label, name = _param.name, initialValue = _param.initialValue, _blockClassName = _param.blockClassName, blockClassName = _blockClassName === void 0 ? "block" : _blockClassName, _readonly = _param.readonly, readonly = _readonly === void 0 ? false : _readonly, inputProps = _objectWithoutProperties(_param, [
        "label",
        "name",
        "initialValue",
        "blockClassName",
        "readonly"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
        name: name,
        initialValue: initialValue,
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: blockClassName,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "label-md text-text-color-high-em dark:text-text-color-high-em-dark",
                        children: label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({
                        readOnly: readonly,
                        type: "text",
                        className: "h-12 mt-0 text-left w-full rounded-lg border-[#D0D5DD] text-text-color-mid-em focus:bg-white focus:ring-0 focus:border-secondary-light"
                    }, input, inputProps))
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormFieldInput);


/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var TextGradient = function(param) {
    var children = param.children, _light = param.light, light = _light === void 0 ? false : _light, _overrideClassName = param.overrideClassName, overrideClassName = _overrideClassName === void 0 ? "" : _overrideClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            backgroundImage: light ? "linear-gradient(to right, #86EFAC, #67E8F9)" : "linear-gradient(to right, #06B6D4, #22C55E)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent"
        },
        className: "".concat(overrideClassName),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextGradient);


/***/ }),

/***/ 740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6194);
/* harmony import */ var react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5249);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var PhoneInput = function(param1) {
    var name = param1.name, initialValue = param1.initialValue, _blockClassName = param1.blockClassName, blockClassName = _blockClassName === void 0 ? "block" : _blockClassName, label = param1.label, labelClassName = param1.labelClassName, phoneInputClassName = param1.phoneInputClassName;
    var labelDefaultClassName = "text-text-color-high-em";
    var phoneInputDefaultClassName = "!w-full !h-12 !rounded-lg";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_3__/* .Field */ .gN, {
        name: name,
        initialValue: initialValue,
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: blockClassName,
                htmlFor: name,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: labelClassName ? labelClassName : labelDefaultClassName,
                        children: label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default()), _objectSpread({
                        country: initialValue,
                        placeholder: "",
                        autoFormat: true,
                        // containerClass="mt-1"
                        inputClass: phoneInputClassName ? phoneInputClassName : phoneInputDefaultClassName,
                        dropdownClass: "text-text-color-high-em"
                    }, input))
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhoneInput);


/***/ }),

/***/ 1253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/button.tsx
var components_button = __webpack_require__(6625);
// EXTERNAL MODULE: ./components/schedule-demo.tsx + 1 modules
var schedule_demo = __webpack_require__(9449);
;// CONCATENATED MODULE: ./components/home-v2/hero.tsx



var HomeHeroSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex h-full xl:h-screen",
        style: {
            backgroundImage: "url(/images/home/home-hero-bg-v2.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-[1536px] m-auto flex flex-col md:space-x-8 lg:space-x-4 md:grid grid-cols-11 py-20 px-6 sm:px-10 md:px-20 xl:px-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-7 md:col-span-6 lg:col-span-7 flex flex-col justify-center space-y-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-white h3 sm:h2 xl:h1",
                            children: "Waste Made Easy"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-white h-2 w-40"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-white subheading",
                                    children: [
                                        "Optimize your waste management programs and\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "inline lg:block",
                                            children: "enhance your company operations."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(schedule_demo/* default */.Z, {
                                    children: function(setIsModalOpen) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                            onClick: function() {
                                                return setIsModalOpen(true);
                                            },
                                            size: "l",
                                            className: "bg-[#166534]",
                                            children: "BOOK A DEMO"
                                        });
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full justify-center md:justify-start mt-10 md:mt-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "max-w-[323px] sm:max-w-[380px] md:max-w-[280px] lg:max-w-[330px] xl:max-w-[430px] 2xl:w-[700px]",
                        src: "/images/home/home-hero-1-v2.png",
                        alt: "Phone"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero = (HomeHeroSection);

;// CONCATENATED MODULE: ./components/home-v2/difference.tsx

var Metric = function(param) {
    var textBold = param.textBold, textNormal = param.textNormal, iconSrc = param.iconSrc, iconAlt = param.iconAlt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col space-y-6 text-center items-center lg:text-start lg:items-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "!w-20",
                src: iconSrc,
                alt: iconAlt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-base-dark",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-body-xl-bold",
                        children: textBold
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    textNormal
                ]
            })
        ]
    });
};
var HomeDifferenceSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-[1536px] m-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-16 py-20 px-10 md:px-20 xl:px-24 xl:py-24 2xl:py-32 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "h3 text-base-dark",
                            children: "The SimpleWaste Difference"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-body-md lg:text-body-lg",
                            children: [
                                "Rapidly recurring ROI, advanced support, and end-to-end functionality equip your team\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "inline lg:block",
                                    children: "for modern-era waste management."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hidden lg:flex flex-row space-x-10 lg:justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                            textBold: "Technology-powered",
                            textNormal: "optimization",
                            iconSrc: "/images/home/homev2-difference-icons/icon-technology-powered.svg",
                            iconAlt: "technology-powered"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                            textBold: "Real-time",
                            textNormal: "visibility dashboard",
                            iconSrc: "/images/home/homev2-difference-icons/icon-real-time.svg",
                            iconAlt: "technology-powered"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                            textBold: "Network",
                            textNormal: "procurement advantage",
                            iconSrc: "/images/home/homev2-difference-icons/icon-network.svg",
                            iconAlt: "technology-powered"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                            textBold: "Sustainability",
                            textNormal: "and KPIs Reporting",
                            iconSrc: "/images/home/homev2-difference-icons/icon-sustainability.svg",
                            iconAlt: "technology-powered"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                            textBold: "24/7",
                            textNormal: "Dedicated LIVE Support",
                            iconSrc: "/images/home/homev2-difference-icons/icon-24-7.svg",
                            iconAlt: "technology-powered"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hidden sm:flex flex-row justify-evenly md:flex-col space-x-10 justify-between lg:hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col space-y-9 md:flex-row md:space-y-0 justify-evenly md:mb-10 lg:mb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                                    textBold: "Technology-powered",
                                    textNormal: "optimization",
                                    iconSrc: "/images/home/homev2-difference-icons/icon-technology-powered.svg",
                                    iconAlt: "technology-powered"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                                    textBold: "Real-time",
                                    textNormal: "visibility dashboard",
                                    iconSrc: "/images/home/homev2-difference-icons/icon-real-time.svg",
                                    iconAlt: "technology-powered"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                                    textBold: "Network",
                                    textNormal: "procurement advantage",
                                    iconSrc: "/images/home/homev2-difference-icons/icon-network.svg",
                                    iconAlt: "technology-powered"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col space-y-9 md:hidden md:flex-row md:space-y-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                                    textBold: "Sustainability",
                                    textNormal: "and KPIs Reporting",
                                    iconSrc: "/images/home/homev2-difference-icons/icon-sustainability.svg",
                                    iconAlt: "technology-powered"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                                    textBold: "24/7",
                                    textNormal: "Dedicated LIVE Support",
                                    iconSrc: "/images/home/homev2-difference-icons/icon-24-7.svg",
                                    iconAlt: "technology-powered"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:flex flex-col space-y-9 justify-evenly md:flex-row md:space-y-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                                    textBold: "Sustainability",
                                    textNormal: "and KPIs Reporting",
                                    iconSrc: "/images/home/homev2-difference-icons/icon-sustainability.svg",
                                    iconAlt: "technology-powered"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                                    textBold: "24/7",
                                    textNormal: "Dedicated LIVE Support",
                                    iconSrc: "/images/home/homev2-difference-icons/icon-24-7.svg",
                                    iconAlt: "technology-powered"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid space-y-8 justify-center sm:hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                            textBold: "Technology-powered",
                            textNormal: "optimization",
                            iconSrc: "/images/home/homev2-difference-icons/icon-technology-powered.svg",
                            iconAlt: "technology-powered"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                            textBold: "Real-time",
                            textNormal: "visibility dashboard",
                            iconSrc: "/images/home/homev2-difference-icons/icon-real-time.svg",
                            iconAlt: "technology-powered"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                            textBold: "Network",
                            textNormal: "procurement advantage",
                            iconSrc: "/images/home/homev2-difference-icons/icon-network.svg",
                            iconAlt: "technology-powered"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                            textBold: "Sustainability",
                            textNormal: "and KPIs Reporting",
                            iconSrc: "/images/home/homev2-difference-icons/icon-sustainability.svg",
                            iconAlt: "technology-powered"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                            textBold: "24/7",
                            textNormal: "Dedicated LIVE Support",
                            iconSrc: "/images/home/homev2-difference-icons/icon-24-7.svg",
                            iconAlt: "technology-powered"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var difference = (HomeDifferenceSection);

;// CONCATENATED MODULE: ./components/home-v2/innovation.tsx

var MetricInno = function(param) {
    var cost = param.cost, subText = param.subText, iconSrc = param.iconSrc, iconAlt = param.iconAlt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center text-center xs:w-36 sm:items-start sm:text-start space-x-0 space-y-6 w-36 md:w-42 lg:w-72 lg:space-y-0 lg:flex-row lg:space-x-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-12 h-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: iconSrc,
                        alt: iconAlt
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "h4 lg:h3",
                            children: cost
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: subText
                        })
                    ]
                })
            ]
        })
    });
};
var HomeInnovationSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-white grid px-6 sm:px-10 py-20 xl:py-24 2xl:py-32 px-6 sm:px-10 md:px-20",
        style: {
            backgroundColor: "#132631"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "m-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col space-y-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col space-y-3 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    className: "h3 text-center",
                                    children: [
                                        "First-in-class",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "block md:inline",
                                            children: " Innovation"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-2 w-40 bg-gradient-to-l from-[#86EFAC] to-[#67E8F9]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pt-5 text-center subheading",
                                    children: "Move your company forward with the industry leader."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden sm:flex flex-col space-y-16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex space-x-6 md:space-x-20 lg:space-x-6 xl:space-x-32",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-savings.svg",
                                        iconAlt: "coins",
                                        cost: "33%",
                                        subText: "Savings AVG"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-operation.svg",
                                        iconAlt: "coins",
                                        cost: "+40%",
                                        subText: "Operations Reduction"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-rfp.svg",
                                        iconAlt: "coins",
                                        cost: "+70%",
                                        subText: "RFP Process Reduction"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex space-x-6 md:space-x-20 lg:space-x-6 xl:space-x-32",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-year-exp.svg",
                                        iconAlt: "coins",
                                        cost: "14+",
                                        subText: "Years Experience"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-software.svg",
                                        iconAlt: "coins",
                                        cost: "21+",
                                        subText: "Software Integrations"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-ancillary.svg",
                                        iconAlt: "coins",
                                        cost: "15+",
                                        subText: "Ancillary Service Options"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sm:hidden space-y-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex space-x-6 justify-center xl:space-x-32",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-savings.svg",
                                        iconAlt: "coins",
                                        cost: "33%",
                                        subText: "Savings AVG"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-operation.svg",
                                        iconAlt: "coins",
                                        cost: "+40%",
                                        subText: "Operations Reduction"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex space-x-6 justify-center xl:space-x-32",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-rfp.svg",
                                        iconAlt: "coins",
                                        cost: "+70%",
                                        subText: "RFP Process Reduction"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-year-exp.svg",
                                        iconAlt: "coins",
                                        cost: "14+",
                                        subText: "Years Experience"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex space-x-6 justify-center xl:space-x-32",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-software.svg",
                                        iconAlt: "coins",
                                        cost: "21+",
                                        subText: "Software Integrations"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricInno, {
                                        iconSrc: "/images/home/homev2-innovation-icons/icon-ancillary.svg",
                                        iconAlt: "coins",
                                        cost: "15+",
                                        subText: "Ancillary Service Options"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var innovation = (HomeInnovationSection);

// EXTERNAL MODULE: ./components/gradient/gradient-text.tsx
var gradient_text = __webpack_require__(3725);
;// CONCATENATED MODULE: ./components/home-v2/outcomes.tsx


var HomeOutcomeSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-[1536px] m-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-6 gap-10 items-center px-6 sm:px-10 py-20 xl:py-24 2xl:py-32 md:px-20 xl:px-24 2xl:gap-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-6 md:col-span-3 space-y-10 justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                            overrideClassName: "h4 lg:h3 xl:h2",
                            children: "BUSINESS OUTCOMES"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid space-y-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/home/homev2-outcome-icons/icon-qoute-left.svg",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-text-color-high-em italic !font-medium h6 lg:h5",
                                    children: "The service and management features within the SimpleWaste platform have been a real game-changer. We\u2019re experiencing lower costs and higher visibility for all levels of management within our company."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "h6 text-text-color-high-em",
                                children: "- National Operator"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-6 m-auto md:col-span-3 justify-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/home/home-outcome-v2.png",
                        alt: "",
                        className: "md:h-[400px] lg:h-auto"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var outcomes = (HomeOutcomeSection);

;// CONCATENATED MODULE: ./components/home-v2/why-user-love-sw.tsx

var HomeWhyUserLoveSimpleWasteSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-[1536px] m-auto ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col space-y-6 py-10 px-6 sm:px-10 md:px-20 xl:px-24 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    className: "h3 sm:h2 text-base-dark lg:h1",
                    children: [
                        "Accelerate",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " With SimpleWaste. "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-2 w-40 bg-gradient-to-l from-[#86EFAC] to-[#67E8F9]"
                })
            ]
        })
    });
};
/* harmony default export */ var why_user_love_sw = (HomeWhyUserLoveSimpleWasteSection);

;// CONCATENATED MODULE: ./components/home-v2/optimize.tsx

var ZPatternList = function(param) {
    var iconSrc = param.iconSrc, iconAlt = param.iconAlt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "mr-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: iconSrc,
            alt: iconAlt
        })
    });
};
var LeftPatternSection = function(param) {
    var imgSrc = param.imgSrc, imgAlt = param.imgAlt, title = param.title, text = param.text, iSrc = param.iSrc, iAlt = param.iAlt, liText1 = param.liText1, liText2 = param.liText2, liText3 = param.liText3, additionalClassname = param.additionalClassname, imageSize = param.imageSize;
    return(// <div className={`flex items-center ${additionalClassname} 
    //                 max-w-[1536px] m-auto flex-col space-y-10 justify-between`
    // }>
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:grid grid-cols-6 gap-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-3 flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: imageSize,
                    src: imgSrc,
                    alt: imgAlt
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-3 space-y-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: iSrc,
                        alt: iAlt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "h4 text-base-dark",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-3 ml-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "space-y-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ZPatternList, {
                                            iconSrc: "/images/home/homev2-zpattern-assets/li-check-icon.svg",
                                            iconAlt: "check"
                                        }),
                                        liText1
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ZPatternList, {
                                            iconSrc: "/images/home/homev2-zpattern-assets/li-check-icon.svg",
                                            iconAlt: "check"
                                        }),
                                        liText2
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ZPatternList, {
                                            iconSrc: "/images/home/homev2-zpattern-assets/li-check-icon.svg",
                                            iconAlt: "check"
                                        }),
                                        liText3
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};
var RightPatternSection = function(param) {
    var imgSrc = param.imgSrc, imgAlt = param.imgAlt, title = param.title, text = param.text, iSrc = param.iSrc, iAlt = param.iAlt, liText1 = param.liText1, liText2 = param.liText2, liText3 = param.liText3, additionalClassname = param.additionalClassname, imageSize = param.imageSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:grid grid-cols-6 gap-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-3 space-y-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: iSrc,
                        alt: iAlt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "h4 text-base-dark",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-3 ml-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "space-y-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ZPatternList, {
                                            iconSrc: "/images/home/homev2-zpattern-assets/li-check-icon.svg",
                                            iconAlt: "check"
                                        }),
                                        liText1
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ZPatternList, {
                                            iconSrc: "/images/home/homev2-zpattern-assets/li-check-icon.svg",
                                            iconAlt: "check"
                                        }),
                                        liText2
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ZPatternList, {
                                            iconSrc: "/images/home/homev2-zpattern-assets/li-check-icon.svg",
                                            iconAlt: "check"
                                        }),
                                        liText3
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-3 flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: imageSize,
                    src: imgSrc,
                    alt: imgAlt
                })
            })
        ]
    });
};
var HomeOptimizeSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-10 px-6 sm:px-10 lg:py-20 md:px-20 xl:px-24 max-w-[1536px] m-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftPatternSection, {
            additionalClassname: "",
            imgSrc: "/images/home/homev2-zpattern-assets/home-optimize.png",
            imageSize: "mb-8 lg:mb-0",
            imgAlt: "tab branch locations",
            iSrc: "/images/home/homev2-zpattern-assets/icon-optimize.svg",
            iAlt: "icon truck",
            title: "Optimize your waste programs with centralized oversight control",
            text: "When it comes to managing waste, there\u2019s no substitute for system control. That\u2019s why SimpleWaste\u2019s platform is designed to centralize point-of-contact, data collection, and support for any sized operation.",
            liText1: "Manage thousands of locations effortlessly",
            liText2: "Consolidate waste stream management",
            liText3: "Standardize operational procedures"
        })
    });
};
/* harmony default export */ var optimize = (HomeOptimizeSection);

;// CONCATENATED MODULE: ./components/home-v2/real-time.tsx



var HomeRealTimeSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-10 px-6 sm:px-10 md:px-20 lg:py-20 xl:px-24 flex max-w-[1536px] m-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden lg:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightPatternSection, {
                    additionalClassname: "",
                    imgSrc: "/images/home/homev2-zpattern-assets/home-realtime.png",
                    imageSize: "",
                    imgAlt: "tab branch locations",
                    iSrc: "/images/home/homev2-zpattern-assets/icon-realtime.svg",
                    iAlt: "icon calendar",
                    title: "Real-Time Visibility Provides Accurate Performance Insights",
                    text: "Real-time tracking is crucial to increasing your company\u2019s productivity goals. When your team is supplied with accurate data, this information provides valuable forecasting insights that allow departments to focus on their core responsibilities, reaching higher levels of efficiency.",
                    liText1: "Provide company-wide visibility",
                    liText2: "Easily measure data analytics",
                    liText3: "Eliminate effort redundancy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block lg:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftPatternSection, {
                    additionalClassname: "",
                    imgSrc: "/images/home/homev2-zpattern-assets/home-realtime.png",
                    imageSize: "",
                    imgAlt: "tab branch locations",
                    iSrc: "/images/home/homev2-zpattern-assets/icon-realtime.svg",
                    iAlt: "icon calendar",
                    title: "Real-Time Visibility Provides Accurate Performance Insights",
                    text: "Real-time tracking is crucial to increasing your company\u2019s productivity goals. When your team is supplied with accurate data, this information provides valuable forecasting insights that allow departments to focus on their core responsibilities, reaching higher levels of efficiency.",
                    liText1: "Provide company-wide visibility",
                    liText2: "Easily measure data analytics",
                    liText3: "Eliminate effort redundancy"
                })
            })
        ]
    });
};
/* harmony default export */ var real_time = (HomeRealTimeSection);

;// CONCATENATED MODULE: ./components/home-v2/manage.tsx


var HomeManageSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-10 px-6 sm:px-10 lg:py-20 md:px-20 xl:px-24 max-w-[1536px] m-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftPatternSection, {
            additionalClassname: "",
            imgSrc: "/images/home/homev2-zpattern-assets/home-manage.png",
            imageSize: "mb-8 lg:mb-0",
            imgAlt: "tab branch locations",
            iSrc: "/images/home/homev2-zpattern-assets/icon-manage.svg",
            iAlt: "icon speedometer",
            title: "Manage Your Programs from a Custom Dashboard",
            text: "Having the right information available to the right team members is important. That\u2019s why SimpleWaste provides custom dashboard views.",
            liText1: "Track relevant information at a glance",
            liText2: "Single-click service requests",
            liText3: "SLA compliance monitoring"
        })
    });
};
/* harmony default export */ var manage = (HomeManageSection);

;// CONCATENATED MODULE: ./components/home-v2/achievable.tsx


var HomeAchievableSectiob = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-10 px-6 mb-10 sm:px-10 md:px-20 lg:py-20 xl:px-24 max-w-[1536px] m-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden lg:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightPatternSection, {
                    additionalClassname: "",
                    imgSrc: "/images/home/homev2-zpattern-assets/home-achievable.png",
                    imageSize: "mb-8 lg:mb-0",
                    imgAlt: "tab branch locations",
                    iSrc: "/images/home/homev2-zpattern-assets/icon-achievable.svg",
                    iAlt: "icon truck",
                    title: "Achieve Sustainability Goals",
                    text: "Centralizing waste stream management provides multiple areas of improvement, including the ability to consolidate raw data. Environmental compliance is an important part of sustainability. We can help.",
                    liText1: "Analyze your environmental impact",
                    liText2: "Increase sustainability awareness",
                    liText3: "Reduce your carbon footprint"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block lg:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftPatternSection, {
                    additionalClassname: "",
                    imgSrc: "/images/home/homev2-zpattern-assets/home-achievable.png",
                    imageSize: "mb-8 lg:mb-0",
                    imgAlt: "tab branch locations",
                    iSrc: "/images/home/homev2-zpattern-assets/icon-achievable.svg",
                    iAlt: "icon truck",
                    title: "Achieve Sustainability Goals",
                    text: "Centralizing waste stream management provides multiple areas of improvement, including the ability to consolidate raw data. Environmental compliance is an important part of sustainability. We can help.",
                    liText1: "Analyze your environmental impact",
                    liText2: "Increase sustainability awareness",
                    liText3: "Reduce your carbon footprint"
                })
            })
        ]
    });
};
/* harmony default export */ var achievable = (HomeAchievableSectiob);

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./components/form/input.tsx
var input = __webpack_require__(2471);
// EXTERNAL MODULE: ./components/phone-input.tsx
var phone_input = __webpack_require__(740);
// EXTERNAL MODULE: ./components/form/dropdown.tsx
var dropdown = __webpack_require__(598);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js + 3 modules
var react_final_form_es = __webpack_require__(5249);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(2920);
// EXTERNAL MODULE: ./lib/api.ts
var api = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/home-v2/waste-management.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}









var DropdownOptions = [
    {
        name: "I want to learn more about your software",
        value: 1
    },
    {
        name: "I am interested in becoming a preffered vendor",
        value: 2
    },
    {
        name: "Others",
        value: 3
    }, 
];
var handleSubmit = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(payload, form) {
        var selectedMessage, newPayload;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    selectedMessage = DropdownOptions.filter(function(item) {
                        return item.value === Number(payload.message);
                    })[0];
                    newPayload = {
                        name: "".concat(payload.firstName, " ").concat(payload.lastName),
                        company: payload.companyName,
                        email: payload.businessEmail,
                        phone: payload.phone,
                        message: selectedMessage ? selectedMessage.name : ""
                    };
                    _ctx.next = 4;
                    return api/* frontendApi.post */.mR.post("/web/get-in-touch", newPayload).then(function(res) {
                        console.log(payload);
                        react_toastify_esm/* toast.success */.Am.success(res.data.message, {
                            position: "bottom-right"
                        });
                        form.reset();
                    }).catch(function(err) {
                        return react_toastify_esm/* toast.error */.Am.error("Something went wrong");
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleSubmit(payload, form) {
        return _ref.apply(this, arguments);
    };
}();
var HomeWasteManagementSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            backgroundImage: "url(/images/home/home-hero-bg.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-white py-20 px-6 sm:px-10 md:px-20 xl:px-24 max-w-[1536px] m-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-6 xl:col-span-4 flex flex-col space-y-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "h3",
                                        children: "Let\u2019s Talk About Transforming Your Waste Management Operations!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Talk to an agent about how SimpleWaste can help you streamline your waste management programs."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block col-span-2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col !space-x-0 item-center justfy-center lg:grid grid-cols-6 space-y-10 xl:!space-x-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-6 xl:col-span-3 m-auto space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-evenly",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "w-[84px]",
                                                src: "/images/home/homev2-waste-management-assets/icon-support.svg",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "w-[84px]",
                                                src: "/images/home/homev2-waste-management-assets/icon-tech.svg",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "w-[84px]",
                                                src: "/images/home/homev2-waste-management-assets/icon-procurement.svg",
                                                alt: ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/home/homev2-waste-management-assets/waste-management.png",
                                            alt: "",
                                            className: "xl:w-[700px] h-auto"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-6 lg:col-start-2 col-end-6 xl:col-span-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                                    onSubmit: handleSubmit,
                                    render: function(param) {
                                        var handleSubmit = param.handleSubmit, form = param.form;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            onSubmit: handleSubmit,
                                            className: "shadow-lg space-y-6 bg-white rounded-lg border-[#D0D5DD] py-16 px-10",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "grid space-x-0 space-y-6 sm:space-y-0 sm:flex sm:space-x-5",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "w-full",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                                label: "First Name*",
                                                                name: "firstName"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "w-full",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                                label: "Last Name*",
                                                                name: "lastName"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "grid space-x-0 space-y-6 sm:space-y-0 sm:flex sm:space-x-5 items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "w-full",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(phone_input/* default */.Z, {
                                                                initialValue: "us",
                                                                name: "phone",
                                                                label: "Phone Number*",
                                                                labelClassName: "text-text-color-high-em label-md",
                                                                phoneInputClassName: "text-text-color-mid-em focus:bg-white focus:ring-0 focus:border-secondary-light !w-full !h-12 !rounded-lg"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "w-full",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                                label: "Business Email*",
                                                                name: "businessEmail"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                    label: "Company Name*",
                                                    name: "companyName"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                                                    name: "message",
                                                    label: "How can we help you?*",
                                                    selectId: "",
                                                    options: DropdownOptions
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex justify-end",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                        type: "submit",
                                                        className: "bg-gradient-to-r to-[#22C55E] from-[#06B6D4] hover:to-[#86EFAC] hover:from-[#67E8F9]",
                                                        size: "l",
                                                        children: "Contact Sales"
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var waste_management = (HomeWasteManagementSection);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./pages/index.tsx

// v1
// import HomeCostCutLikeAProSection from "@app/components/home/cost-cut-like-a-pro";
// import HomeHeroSection from "@app/components/home/hero";
// import HomeManagementSection from "@app/components/home/management";
// import HomeScheduleDemoSection from "@app/components/home/schedule-demo";
// import HomeSwitchToSimpleWasteSection from "@app/components/home/switch-to-simplewaste";
// import HomeTechStackSection from "@app/components/home/tech-stack";
// import HomeWhyHaulersWorkWithUsSection from "@app/components/home/why-haulers-work-with-us";
// import HomeWhyUserLoveSimpleWasteSection from "@app/components/home/why-user-love-simplewaste";
// v2











// v1
// const HomePage = () => <Fragment>
//     <HomeHeroSection />
//     <HomeManagementSection />
//     {/* <HomeTechStackSection /> */}
//     <HomeCostCutLikeAProSection />
//     <HomeWhyUserLoveSimpleWasteSection />
//     <HomeSwitchToSimpleWasteSection />
//     <HomeWhyHaulersWorkWithUsSection />
//     <HomeScheduleDemoSection />
// </Fragment>
// v2
var HomePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "overflow-x-hidden",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(hero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(difference, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(innovation, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(outcomes, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(why_user_love_sw, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(optimize, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(real_time, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(manage, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(achievable, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(waste_management, {})
            ]
        })
    });
};
/* harmony default export */ var pages = (HomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [425,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);